import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { stCharlesMOConfig } from "./data";

export default function StCharlesPage() {
  return <CityPageTemplate config={stCharlesMOConfig} />;
}